import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HTTP_STATUS_CODES } from '@bbraun/cortex/number-input';
import { Observable, tap } from 'rxjs';

import { ROUTES } from '@/app/shared/util-common/navigation/routes.constants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        error: (error: any) => {
          if (!(error instanceof HttpErrorResponse)) return;

          if (error.status === HTTP_STATUS_CODES.SERVICE_UNAVAILABLE) {
            this.router.navigate([ROUTES.ERROR.ERROR, ROUTES.ERROR.SERVICE_UNAVAILABLE]);
          }

          if (error.status === HTTP_STATUS_CODES.NOT_FOUND) {
            this.handleNotFound(error);
          }

          if (error.status === HTTP_STATUS_CODES.FORBIDDEN) {
            this.handleForbidden(error);
          }

          if (error.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
            this.handleServerError(error);
          }

          if (error.status === HTTP_STATUS_CODES.BAD_REQUEST) {
            this.handleBadRequest(error);
          }
        },
      }),
    );
  }

  private handleNotFound(error: HttpErrorResponse): void {
    if (error.url!.indexOf('excludeGroupId') > -1) {
      return;
    }

    if (error.url!.indexOf('releases') > -1 || error.url!.indexOf('deployments?siteId') > -1) {
      this.router.navigate([ROUTES.RELEASES.RELEASES, ROUTES.RELEASES.NOT_FOUND]);
      return;
    }

    if (
      error.url!.indexOf('api/di/v1/products/') > -1 ||
      (error.error?.description?.indexOf('/api/v1/devices/product/') > -1 &&
        error.url?.indexOf('/api/di/v1/devices?siteId')! > -1 &&
        globalThis.location.href.indexOf('details') === -1)
    ) {
      // editing product id during registration should be ignored since error is shown inline in modal
      // registering single product should be ignored since error is shown inline in modal
      return;
    }

    this.router.navigate([ROUTES.DEPLOYMENTS.DEPLOYMENTS, ROUTES.DEPLOYMENTS.NOT_FOUND]);
  }

  private handleForbidden(error: HttpErrorResponse): void {
    if (error.url!.indexOf('releases') > -1 || error.url!.indexOf('deployments?siteId') > -1) {
      this.router.navigate([ROUTES.RELEASES.RELEASES, ROUTES.RELEASES.FORBIDDEN]);
      return;
    }

    this.router.navigate([ROUTES.DEPLOYMENTS.DEPLOYMENTS, ROUTES.DEPLOYMENTS.FORBIDDEN]);
  }

  private handleServerError(error: HttpErrorResponse): void {
    if (error.url!.indexOf('releases') > -1 || error.url!.indexOf('deployments?siteId') > -1) {
      this.router.navigate([ROUTES.RELEASES.RELEASES, ROUTES.RELEASES.SERVER_ERROR]);
      return;
    }

    this.router.navigate([ROUTES.DEPLOYMENTS.DEPLOYMENTS, ROUTES.DEPLOYMENTS.SERVER_ERROR]);
  }

  private handleBadRequest(error: HttpErrorResponse): void {
    if (error.url!.indexOf('release') > -1) {
      this.router.navigate([ROUTES.RELEASES.RELEASES, ROUTES.RELEASES.BAD_REQUEST]);
      return;
    }

    this.router.navigate([ROUTES.DEPLOYMENTS.DEPLOYMENTS, ROUTES.DEPLOYMENTS.BAD_REQUEST]);
  }
}
